(() => {
  // Auto-Gift: legt beim Add-to-Cart des Hauptprodukts automatisch das
  // Gratis-Geschenk in den Warenkorb (Preis wird durch den Shopify-
  // "Buy X get Y"-Rabatt auf 0 gesetzt). Konfiguriert am Produkt-Metafeld
  // custom.auto_gift_variant; Trigger sind alle Varianten des Produkts.
  const loader = document.currentScript;
  const gift = Number(loader?.dataset.giftVariant);
  const triggers = (loader?.dataset.triggerVariants || '')
    .split(',')
    .map(Number)
    .filter(Boolean);

  if (!gift || !triggers.length) return;

  const origFetch = window.fetch;

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = String(
      (init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET'
    ).toUpperCase();
    const isAdd = method === 'POST' && url.indexOf('/cart/add') !== -1;

    const res = await origFetch.apply(this, arguments);

    if (!isAdd || !res.ok) return res;

    try {
      const body = init && init.body;
      let addsTrigger = false;
      let addsGift = false;

      if (typeof body === 'string') {
        addsTrigger = triggers.some((t) => body.indexOf(String(t)) !== -1);
        addsGift = body.indexOf(String(gift)) !== -1;
      } else if (body instanceof FormData) {
        const id = Number(body.get('id'));
        addsTrigger = triggers.includes(id);
        addsGift = id === gift;
      }

      if (!addsTrigger || addsGift) return res;

      const cart = await origFetch('/cart.js').then((r) => r.json());
      const hasTrigger = cart.items.some((i) => triggers.includes(i.variant_id));
      const hasGift = cart.items.some((i) => i.variant_id === gift);

      if (hasTrigger && !hasGift) {
        await origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: gift, quantity: 1 }] })
        });
      }
    } catch (e) {
      /* Gift-Add darf den normalen Kauf nie blockieren */
    }

    return res;
  };
})();
